import Provider from "../Provider";
import TrackingTimeContextType from "./TrackingTimeContextType";

export default interface TrackingTimeProvider extends Provider<TrackingTimeContextType> {
}

export const TrackingTimeProviderName = "TrackingTimeProvider";